<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-rect`]" width="1em" height="1em" v-bind="$attrs"><rect x="1.919" y="3.5" width="20.162" height="17.004" rx="4" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><rect x="6.558" y="8.078" width="10.885" height="7.852" rx="2" stroke="#00BBD8" stroke-width="1.66" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorRect',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
